import React, { FC, ButtonHTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  disabled?: boolean;
  className?: string;
}

const IconButton: FC<ButtonProps> = ({
  children,
  disabled = false,
  className = '',
  ...props
}) => {
  return (
    <button
      className={clsx(
        'p-1 flex items-center text-semiBold rounded-small font-semibold',
        { 'cursor-default opacity-40': disabled },
        className
      )}
      {...props}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default IconButton;
